import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import { filterReportAppointments } from 'lib/helper'

import AppointmentCardList from 'components/AppointmentCardList'
import Text from 'components/Text'
import StatusDisplay from 'components/StatusDisplay'
import ColorCodeExplanation from 'components/ColorCodeExplanation'
import MonthSelector from 'components/MonthSelector'
import FontAwesome from 'react-fontawesome'

class AppointmentsReportScreen extends React.Component {

  constructor(props) {
    super(props)
    this.handleDateChange = this.handleDateChange.bind(this)
  }

  handleDateChange(date) {
    const { onLoadReportFromDate } = this.props
    onLoadReportFromDate(date)
  }

  render() {
    const { report, ui, onAppointmentStart, onPromptCompleteAppointment, onPromptCancelAppointment, onRefresh } = this.props

    // Filter appointments to show only necessary ones
    const a = report.appointments || []
    const appointments = filterReportAppointments(a)

    return (
      <div className="AppointmentsReportScreen">

        {/* Controls and labels */}
        <div className="AppointmentsReportScreen_Header">
          <div className="AppointmentsReportScreen_Controls">
            <MonthSelector onSelect={this.handleDateChange} />
            <FontAwesome name="refresh" size="lg" onClick={onRefresh} />
          </div>
          <ColorCodeExplanation showCancelled />
        </div>

        {/* Appointment list */}
        {ui.agendaReports.isLoading ? <StatusDisplay status={ui.agendaReports}>Erro ao carregar histórico</StatusDisplay> :
          !appointments.length ?
            <Text>Nenhuma consulta encontrada no período selecionado</Text>
            :
            <AppointmentCardList
              appointments={appointments}
              onAppointmentStart={onAppointmentStart}
              onAppointmentComplete={onPromptCompleteAppointment}
              onAppointmentCancel={onPromptCancelAppointment}
            />
        }

      </div>
    )
  }
}
AppointmentsReportScreen.propTypes = {
  report: PropTypes.object.isRequired,
  onLoadReportFromDate: PropTypes.func.isRequired,
  onAppointmentStart: PropTypes.func.isRequired,
  onPromptCompleteAppointment: PropTypes.func.isRequired,
  onPromptCancelAppointment: PropTypes.func.isRequired,
  ui: PropTypes.object.isRequired,
}

export default AppointmentsReportScreen



// WEBPACK FOOTER //
// ./src/components/_Screens/AppointmentsReport/index.js